import { UseMutateFunction } from '@tanstack/react-query';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Button, message } from 'antd';

import { ResetPasswordFormInputs } from 'types';

import { Input } from '../common/input';
import useTranslation from '../../customHooks/translate';

interface IProps {
  passwordResetHandler: UseMutateFunction<any, unknown, any>;
  token: string;
  passwordError?: string | null;
  consfirmPasswordError?: string | null;
  isLoading: boolean;
}

const ResetPasswordForm = ({
  passwordResetHandler,
  token,
  passwordError,
  consfirmPasswordError,
  isLoading,
}: IProps) => {
  const translation = useTranslation();
  const { register, handleSubmit, watch, formState } =
    useForm<ResetPasswordFormInputs>();
  const { errors } = formState;

  let pwd = watch('password');

  const onSubmit: SubmitHandler<ResetPasswordFormInputs> = (body) => {
    if (!body.password || !body.confirmPassword) {
      message.error(translation.login.emptyFields);
      return;
    }

    passwordResetHandler(body);
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-[24px]"
      >
        <div className="flex flex-col gap-[8px]">
          <Input
            id="password"
            label={translation.register.SetNewPassword}
            placeholder="• • • • • • • •"
            error={errors.password}
            type="password"
            autoComplete="current-password"
            {...register('password', {
              required: translation.passwordRequired,
            })}
          />

          {errors.password && (
            <span
              className="animate__animated animate__shakeX"
              style={{ color: 'red', fontSize: '12px' }}
            >
              {errors.password.message}
            </span>
          )}
          {passwordError && (
            <span
              className="animate__animated animate__shakeX"
              style={{ color: 'red', fontSize: '12px' }}
            >
              {passwordError}
            </span>
          )}
        </div>
        <div className="flex flex-col gap-[8px]">
          <Input
            id="password-repeat"
            label={translation.password.PasswordConfirm}
            placeholder="• • • • • • • •"
            error={errors.confirmPassword}
            type="password"
            {...register('confirmPassword', {
              validate: (value) =>
                value === pwd || translation.passwordNotMatch,
            })}
          />

          {errors.confirmPassword && (
            <span
              className="animate__animated animate__shakeX"
              style={{ color: 'red', fontSize: '12px' }}
            >
              {errors.confirmPassword.message}
            </span>
          )}
          {consfirmPasswordError && (
            <span
              className="animate__animated animate__shakeX"
              style={{ color: 'red', fontSize: '12px' }}
            >
              {consfirmPasswordError}
            </span>
          )}
        </div>
        <input type="hidden" value={token} {...register('token')} />
        <Button
          htmlType="submit"
          className="h-[44px] rounded-md !border-0 !bg-[#6DCE92] font-medium !text-white shadow-none transition-colors duration-200 hover:!border-0 hover:!bg-[#5EC082] hover:!text-white focus:!border-0 focus:!bg-[#6DCE92] focus:!text-white active:!border-0 active:!bg-[#5EC082] active:!text-white"
          loading={isLoading}
        >
          {translation.resetPassword.ResetYourPassword}
        </Button>
      </form>
    </>
  );
};

export default ResetPasswordForm;
